// removed by extract-text-webpack-plugin
module.exports = {"head-tracking":"head-tracking__head-tracking___Nr6aB","head-tracking__video":"head-tracking__head-tracking__video___3sTmP","head-tracking__canvas":"head-tracking__head-tracking__canvas___1txJ-"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Head-tracking/head-tracking.scss
// module id = 123
// module chunks = 0